const COHORT_STATUS = {
  NOT_STARTED: 'not_started',
  LIVE: 'live',
  ENDED: 'ended',
  CANCELED: 'canceled',
};

export default COHORT_STATUS;
